import React, { createRef } from 'react';
import styled from 'styled-components';
import { PostData } from '../components/Functions/SendingData';
import BreadCromb from '../components/HomeComp/BreadCromb';
import { LoadingWLogo } from '../components/LoadingWLogo';
import { Loading } from '../components/Loading';
import PageTitlesFunc from '../components/Functions/PageTitlesFunc';
import { visitProductDataLayer } from '../components/Functions/DataLayers';
import { goodpageText } from '../Lang/fa/Goodpage';
// import MakeThisNoIndex from '../components/Functions/MakeThisNoIndex';
import GoodHeader2 from '../components/HomeComp/GoodHeaderV2Main';
import GoodBody2 from '../components/HomeComp/GoodBodyV2Main';
import Carousel22 from '../components/HomeComp/Carousel2-2';
import NoMatch from './NoMatch';

const Styles = styled.div`
    margin: var(--padding-top) 0 0;
    .main-container {
        text-align: center;
        font-size: 2em;
        direction: rtl;
    }
    .good-data {
        margin: 0 0 60px;
        width:100%;
        direction: rtl;
    }
    .good-data .header {
        transition: all 0.3s ease-in-out;
    }
    .good-data .carousel-same{
        width: calc(100% - var(--width-padding));
        padding: 0 var(--padding);
    }

    .good-data .footer {
        background-color: #fff;
        border-radius: 1rem;
        box-shadow: 0 5px 10px -8px #888;
        padding: 1rem;
        margin: 1rem 0;
        transition: all 0.3s ease-in-out;
    }
    .good-data .footer:hover {
        box-shadow: 0 5px 10px -2px #888;
    }
    .deviderView{
        margin-top: 1rem;
        width: calc(100% - var(--width-padding));
        padding: 2rem var(--padding);
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .same{
            font-weight: 700;
            font-size: 1.25rem;
            color: var(--gray-10);
        }

    }
   
    @media screen and (max-width: 850px) {
        /* margin: 138px 0 0; */
        .main-container {
        }
        .cromb{
            margin-top: 135px;
        }
        .good-data{
            margin: 0 auto 60px;
            .carousel-same{
                padding: 0;
                width: 100%;
            }
        }
        .deviderView{
            margin-top:0;
            padding: 1rem var(--padding);
        }
    }
`

class GoodPage2 extends React.Component {
    constructor(props) {
        super(props);
        this.refScroll = createRef()
        this.state = {
            userdata: JSON.parse(localStorage.getItem('userdata')),
            g_code: props.match.params.g_code,
            sh_code: '',
            selectedattr:false,
            select:false,
            return404: false,
            page:0,
            userAllow:'',
            favorite:'',
            objectData: '',
            objectData2: [],
            sending:true ,
            sending2:true ,
            shgcode:'',
            listShops: [],
            listImages: [],
        };
    }
    componentDidMount () {
        this.beforeLoad()
        this.getData();
        this.sameGood();
        this.visitGood();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    beforeLoad = () => {
        let page = decodeURI(window.location.pathname).split("/");
        if(page.length === 5){
            let name = page[3].replaceAll("-", " ")
            PageTitlesFunc({
                title : name + ' - لوکسین لوکس '   , 
                description: " خرید اینترنتی " +  name  + ' در فروشگاه لوکسین لوکس ', 
                canonical: 'https://' + window.location.hostname + '/good/' + page[2] + '/'+page[3]+'/'
            })
        }
    }


    // get if gcode or shop code has changed
    getSnapshotBeforeUpdate(prevProps, prevState){
        if (
            prevProps.match.params.g_code !== this.props.match.params.g_code
             ||
            prevProps.location.state !== this.props.location.state
        ){
            return true;
        } else {
            return false;
        }
    }
    // if updated get data from server
    componentDidUpdate(prevProps, prevState, snapshot){
        if (snapshot){
            this.beforeLoad()
            this.getData();
            this.setState({
                g_code: this.props.match.params.g_code,
                sh_code: '',
            });
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
    getData = () => {
        let formData = new FormData();
        formData.append('G_CODE',this.props.match.params.g_code);
        let userdata = this.state.userdata;
        if(userdata && userdata.usercode){
            formData.append('api_token', this.state.userdata.token);
            formData.append('U_CODE',userdata.usercode);
        }else{
            formData.append('U_CODE',-1);
        }
        if(this.props.location.state){
            if(this.props.location.state.shopcode){
                formData.append('SH_CODE',this.props.location.state.shopcode);
                this.setState({
                    sh_code: this.props.location.state.shopcode
                })
            }
        }
        this.setState({
            selectedattr:false,
            select:false,
            page:0,
            response: 'pending',
            objectData: {},
            goods_shop: [],
            userOrder: [],
            sending: true
        });
        PostData(process.env.REACT_APP_API + '/api/v1/exb/goods/select',formData, this, this.Proccess);
    }
    Proccess(obj, data ){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            let attri = false;
            //
            // if(decodeURI(window.location.pathname) !== '/good/' + response.data.G_CODE + '/'+response.data.G_URL+'/'){
            //     // 404
            //     obj.setState({
            //         return404: true,
            //         sending: false,
            //         response: 'success',
            //     });
            //     return;
            // }
            
            if(response.goods_shop[0]){
               attri= response.goods_shop[0].G_COL_CODE
            }

            if(obj.props.location.search !== ""){
                let split = obj.props.location.search.split("&");
                let find = split.find((v) => v.search("varient=") !== -1);
                if(find){
                    let colsplit = find.split("varient=");
                    attri = parseInt(colsplit[1]);
                }
            };

            let findShop = response.goods_shop.find((v) => v.G_COL_CODE === attri);
            if(!findShop){
                findShop = response.goods_shop[0]
            }

            let listShops = [];
            let listImages = [];
            for (let i = 0; i < response.goods_shop.length; i++) {
                const shopgood = response.goods_shop[i];
                let findShop2 = listShops.findIndex((v) => v.SH_CODE === shopgood.SH_CODE);
                if(findShop2 === -1){
                    listShops.push({
                        SH_CODE: shopgood.SH_CODE,
                        SH_LOGO: shopgood.SH_LOGO,
                        SH_NAME: shopgood.SH_NAME,
                        goods: [shopgood]
                    })
                    if(shopgood.SHOP_GOODS_IMAGE && shopgood.SHOP_GOODS_IMAGE.length){
                        listImages.push(...shopgood.SHOP_GOODS_IMAGE)
                    }
                } else {
                    listShops[findShop2].goods.push(shopgood);
                    if(shopgood.SHOP_GOODS_IMAGE && shopgood.SHOP_GOODS_IMAGE.length){
                        listImages.push(...shopgood.SHOP_GOODS_IMAGE)
                    }
                }
            }




            // if(obj.props.location.pathname){
            //     let split = obj.props.location.pathname.split('/')[3];
            //     if(split !== response.data.G_URL){
            //         let url = response.data.G_URL+'/'
            //         obj.props.history.push(url)
            //     }
            // };

            visitProductDataLayer(response.data);

            obj.setState({
                response: 'success',
                objectData: response.data,
                goods_shop:response.goods_shop,
                sending: false,
                userAllow: response.user_allow_comment,
                selectedattr : attri,
                shop_count : response.shop_count,
                select: (attri ? true : false),
                favorite: response.is_favorite,
                userOrder : response.last_user_order,
                shgcode : (findShop) ? findShop.SH_G_CODE : "",
                listShops: listShops,
                listImages: listImages,
                cmCount: response.comment_count
            });
            PageTitlesFunc({
                title : response.data.G_NAME + " | " + response.data.G_LATIN_NAME + ' - لوکسین لوکس '   , 
                description: " خرید اینترنتی " +  response.data.G_NAME  + ' به همراه لیست قیمت جدیدترین محصولات '  + response.data.G_GR_NAME + ' در فروشگاه لوکسین لوکس ', 
                canonical: 'https://' + window.location.hostname + '/good/' + response.data.G_CODE + '/'+response.data.G_URL+'/'
            })
            // if(response.data.G_CONTROL){
                
            // } else {
            //     MakeThisNoIndex({
            //         title : response.data.G_NAME + ' - لوکسین لوکس '   , 
            //         description: " خرید اینترنتی " +  response.data.G_NAME  + ' به همراه لیست قیمت جدیدترین محصولات '  + response.data.G_GR_NAME + ' در فروشگاه لوکسین لوکس ', 
            //         canonical: 'https://' + window.location.hostname + '/good/' + response.data.G_CODE + '/'+response.data.G_URL+'/'
            //     })
            // }
        } else if (response.status === 'error') {
            obj.setState({
                return404: true,
                sending: false,
                response: 'success',
            });
            return;
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }
    sameGood=()=> {
        let formData = new FormData();
        formData.append('G_CODE',this.props.match.params.g_code);
        this.setState({
            sending2: true,
        });
        PostData(process.env.REACT_APP_API + '/api/v1/exb/goods/select_similar_goods',formData, this, this.SProccess);    
    }
    SProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectData2: response.data,
                sending2: false
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending2: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending2: false
            });
        }
    }
    visitGood=()=>{
        let formData = new FormData();
        formData.append('G_CODE',this.props.match.params.g_code);
        let userdata = this.state.userdata;
        if(userdata && userdata.usercode){
            formData.append('api_token',this.state.userdata.token);
            formData.append('U_CODE', userdata.usercode);
        }else{
            formData.append('U_CODE', -1);
        }
        if(this.props.location.state){
            if(this.props.location.state.shopcode){
                formData.append('SH_CODE',this.props.location.state.shopcode);
            }   
        }
        PostData(process.env.REACT_APP_API + '/api/v1/goods/user_views/visit',formData, this, this.VProccess);    
    }
    VProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectData3: response.data,
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
            });
        }
    }
    makeBreadCrombData = ()=> {
        let data = this.state.objectData;
        let breadData = []
        if(this.state.sh_code !== ''){
            breadData.push(
                {
                    name:((this.state.goods_shop.length > 0) ? this.state.goods_shop[0].SH_NAME : this.state.sh_code),
                    link: '/shop/'+ this.state.sh_code
                }
            )
            breadData.push(
                {
                    name: data.G_GR_NAME ,
                    link: '/search/'+ data.G_GR_EN_NAME ,
                    shopcode:this.state.sh_code,
                    shopname:((this.state.goods_shop.length > 0) ? this.state.goods_shop[0].SH_NAME : this.state.sh_code)
                },
                {
                    name:  data.G_TAG_NAME ,
                    link: '/search/'+ data.G_GR_EN_NAME + '/' + data.G_TAG_EN_NAME+'/',
                    // diactive: false
                },
                {
                    name:  data.G_SUBGR_NAME ,
                    link: '/search/'+  data.G_SUBGR_EN_NAME +'/',
                    shopcode:this.state.sh_code,
                    shopname:((this.state.goods_shop.length > 0) ? this.state.goods_shop[0].SH_NAME : this.state.sh_code)
                },
                // {
                //     name: data.G_NAME,
                //     link: '/good/'
                // }
            )
        }else{
            breadData.push(
                {
                    name: 'خانه',
                    link: '/'
                },
            )
            breadData.push(
                {
                    name: data.G_GR_NAME ,
                    link: '/category/'+ data.G_GR_EN_NAME +'/'
                },
            )
            breadData.push(
                {
                    name:  data.G_TAG_NAME ,
                    link: '/category/' + data.G_TAG_EN_NAME+'/',
                    // diactive: false
                },
                {
                    name:  data.G_SUBGR_NAME ,
                    link: '/category/'+  data.G_SUBGR_EN_NAME +'/'
                },
                // {
                //     name: data.G_NAME,
                //     link: '/good/'
                // }
            )
        }       
        return breadData;
    }
    scrollDesc = () => {
        let newScroll = this.refScroll.current.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({
            top: newScroll,
            left: 0,
            behavior: "smooth"
        })
    }
    attrSelected=(att)=>{
        this.setState({
            selectedattr : att,
            select: true
        })
    }
    makeCarousel=()=>{
        if(!this.state.sending2){
                return (
                    <Carousel22 objects={this.state.objectData2} dashView={'samegood'}/>
                )
            
        }else{
            return <Loading/>
        }
    }
    filterShops = (shops) => {
        let newshops = shops.filter((pr)=>{
            if(this.state.selectedattr){
              return parseInt(pr.G_COL_CODE) === parseInt(this.state.selectedattr)
            }
            return true
        })
        return newshops;
    }
    makeGoodData = () => {
        if(!this.state.sending) {
            let data = this.state.objectData;
            return (
                <React.Fragment>
                    <div className="header">
                        <GoodHeader2
                            shcode={this.state.sh_code} 
                            name={data.G_NAME} 
                            desc={data.G_SHORT_DESC} 
                            image={data.G_IMAGE} 
                            all={data} 
                            goods_shop={this.state.goods_shop} 
                            attr={this.state.selectedattr} 
                            attrFunc={(att)=>this.attrSelected(att)} 
                            userAllow={this.state.userAllow} 
                            page={this.state.page} 
                            changeTab={(p)=>this.ClickedNav(p)} 
                            favorite={this.state.favorite} 
                            select={this.getData} 
                            shop_count={this.state.shop_count} 
                            listshops={this.state.listShops}
                            listImages={this.state.listImages}
                            scrollDesc={this.scrollDesc}
                            {...this.props}
                        />
                    </div>
                    <div className="body" id='description' ref={this.refScroll}>
                        <GoodBody2 cmCount={this.state.cmCount} class={this.state.allshop} shgcode={this.state.shgcode} shcode={this.state.sh_code} name={data.G_NAME} fDesc={data.G_FULL_DESC} technical={data.G_TECHNICAL_DESC}  all={data} goods_shop={this.state.goods_shop} attr={this.state.selectedattr}  page={this.state.page} changeTab={(p)=>this.ClickedNav(p)} userAllow={this.state.userAllow} code={data.G_CODE} {...this.props} userOrder={this.state.userOrder[0]} func={this.scrollSeler} makeShopGoods={this.makeShopGoods}/>
                    </div>
                    {
                        (!this.state.sending2 && this.state.objectData2.length) 
                        ? (
                            <React.Fragment>
                                <div className='deviderView'>
                                    <span className='same'>{goodpageText.same}</span>
                                    {/* <span className='more-home2'>مشاهده بیشتر</span> */}
                                </div>
                                <div className='carousel-same'>
                                    {this.makeCarousel()}
                                </div>
                            </React.Fragment>
                        ) : (
                            ''
                        )
                    }
                </React.Fragment>
            )
        } else {
            return <LoadingWLogo/>
        }
        
    }

    breadCromb=()=>{
        if(this.state.objectData) {
            return( <BreadCromb data={this.makeBreadCrombData()} />)
        }
    }
    render() {
        if(this.state.return404){
            return <NoMatch/>
        }
        return (
            <React.Fragment>
                <Styles >
                    {this.breadCromb()}
                    <div className="good-data">
                        {this.makeGoodData()}
                    </div>
                </Styles>
            </React.Fragment>
        )
    }

}
export default GoodPage2;
